import(/* webpackMode: "eager" */ "/codebuild/output/src2197775355/src/apps/jumplab/src/app/error.tsx");
